/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Stock_Blackbird_EnrichInputs */

const fr_weak_stock_blackbird_enrich = /** @type {(inputs: Weak_Stock_Blackbird_EnrichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Weak_Stock_Blackbird_EnrichInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weak_stock_blackbird_enrich = /** @type {((inputs?: Weak_Stock_Blackbird_EnrichInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Stock_Blackbird_EnrichInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weak_stock_blackbird_enrich(inputs)
});